import { render, staticRenderFns } from "./RegistrationHeader.vue?vue&type=template&id=12b70b94&scoped=true&"
import script from "./RegistrationHeader.vue?vue&type=script&lang=js&"
export * from "./RegistrationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b70b94",
  null
  
)

export default component.exports